module.exports = __webpack_public_path__ + "bc826b39ed201dcef8164c31c2fef50b.pdf";